import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";

const ContactSection = () => {
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formLoading, setFormLoading] = useState(false);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch("https://allinoneai-d1a5a1b54c64.herokuapp.com/api/contact-section");
        if (!response.ok) {
          throw new Error("Failed to fetch contact section data");
        }
        const data = await response.json();
        if (!data.success) {
          throw new Error(data.message || "Failed to fetch contact section data");
        }
        setContactData(data.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching contact section data:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchContactData();
  }, []);

  const UserContactMessage = (event) => {
    event.preventDefault();
    setFormLoading(true);
    
    // Fixed don't change it: Using correct form field names that match the input names
    const ticketUserName = event.target.name.value;
    const ticketUserEmail = event.target.email.value;
    const message = event.target.message.value;
    const subject = event.target.subject.value;
    const phone = event.target.phone ? event.target.phone.value : "";
    const ticketStatus = "open";
    const contact = {
      ticketUserName,
      ticketUserEmail,
      message,
      subject,
      phone,
      ticketStatus,
      createdAt: new Date(),
      ticketUserRole: "user",
    };
    
    const url = `/new-support-message`;
    fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(contact),
    })
      .then((res) => res.json())
      .then((result) => {
        event.target.reset();
        toast.success("Message Sent Successfully!");
        setFormLoading(false);
      })
      .catch((error) => {
        toast.error("Failed to send message. Please try again.");
        console.error("Error sending message:", error);
        setFormLoading(false);
      });
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden"></span>
        </div>
       
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        Error: {error}
      </div>
    );
  }

  if (!contactData || !contactData.isActive) {
    return null; // Don't render if inactive or no data
  }

  return (
    <>
      <section className="contact-info-section section-padding position-relative py-5">
        <div className="container mt-5">
          <div className="row justify-content-center g-4 text-center">
            {contactData.contactInfo.map((info, index) => (
              <div
                key={info.id}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`${0.1 * (index + 1)}s`}
              >
                <div className="contact-info-card glass-panel p-4 p-md-5 rounded-4 border border-secondary h-100 d-flex flex-column align-items-center">
                  <div className="icon-wrapper mb-4 d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: "80px", height: "80px", background: "rgba(99, 102, 241, 0.1)" }}>
                    <i className={`${info.iconClass} fs-2 text-gradient`}></i>
                  </div>
                  <h4 className="text-white mb-3">{info.title}</h4>
                  <p className="text-secondary mb-0" dangerouslySetInnerHTML={{ __html: info.content }} style={{ lineHeight: "1.7" }} />
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <style jsx>{`
          .text-gradient {
            background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .contact-info-card {
            transition: transform 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease;
          }
          .contact-info-card:hover {
            transform: translateY(-8px);
            border-color: rgba(99, 102, 241, 0.3) !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          }
          .icon-wrapper {
            transition: transform 0.3s ease;
          }
          .contact-info-card:hover .icon-wrapper {
            transform: scale(1.1);
          }
        `}</style>
      </section>
      
      <section id="contact" className="contact-form-section section-padding position-relative py-5 mb-5 overflow-hidden">
        {/* Background Gradients */}
        <div className="position-absolute top-50 start-50 translate-middle w-100 h-100 z-n1" style={{ background: "radial-gradient(circle at center, rgba(236, 72, 153, 0.05) 0%, transparent 70%)" }}></div>

        <div className="container">
          <div className="section-title text-center mb-5 pb-3">
            <h2 className="display-5 fw-bold text-white">{contactData.sectionTitle}</h2>
          </div>
          
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 wow fadeInUp" data-wow-delay="0.2s">
              <div className="contact-form-wrapper glass-panel p-4 p-md-5 rounded-4 border border-secondary shadow-lg">
                <form
                  className="contact-form"
                  name="enq"
                  method="post"
                  onSubmit={UserContactMessage}
                >
                  <div className="row g-4">
                    {contactData.formFields.map((field) => (
                      <div key={field.name} className={`${field.colWidth}`}>
                        <label htmlFor={field.name} className="form-label text-secondary fw-medium small text-uppercase tracking-wider mb-2">{field.label}</label>
                        {field.type === "textarea" ? (
                          <textarea
                            rows={5}
                            name={field.name}
                            id={field.name}
                            className="form-control form-control-lg bg-dark text-white border-secondary"
                            required={field.required}
                            placeholder={`Enter ${field.label.toLowerCase()}`}
                          />
                        ) : (
                          <input
                            type={field.type}
                            name={field.name}
                            id={field.name}
                            className="form-control form-control-lg bg-dark text-white border-secondary"
                            required={field.required}
                            placeholder={`Enter ${field.label.toLowerCase()}`}
                          />
                        )}
                      </div>
                    ))}
                    <div className="col-12 text-center mt-5">
                      <button
                        type="submit"
                        name="submit"
                        id="submitButton"
                        className="btn btn-primary btn-lg px-5 py-3 rounded-pill shadow-glow w-100 w-md-auto"
                        disabled={formLoading}
                      >
                        {formLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : (
                          <>
                            {contactData.buttonText} <i className="fa-solid fa-paper-plane ms-2"></i>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .tracking-wider {
            letter-spacing: 0.05em;
          }
          .form-control:focus {
            border-color: var(--accent-primary) !important;
            box-shadow: 0 0 0 0.25rem rgba(99, 102, 241, 0.25) !important;
          }
          .shadow-glow {
            box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);
          }
        `}</style>
      </section>
    </>
  );
};

export default ContactSection;